module.exports = _.initial;